/** Ruta base del informe (menú: Contabilidad → Reportes). */
export const WALLET_ACCOUNTING_SYNC_BASE_PATH = '/reports/wallet-accounting-sync';
